import { padTime } from "../PadString";
var cache = {};
var cache2 = {};
var cache3 = {};
var cache4 = {};
/**
 * parseTime - returns values 0 - 10 like SS, and values above like MM:SS
 * @param {ms} number
 */
export function parseTime(ms) {
    var toSeconds = Math.ceil(Math.abs(ms) / 1000);
    if (!cache[toSeconds]) {
        var sec = toSeconds % 60;
        var min = Math.ceil((toSeconds - sec) / 60);
        cache[toSeconds] = (min > 0 || sec > 10) ? padTime(min.toString()) + ":" + padTime(sec.toString()) : sec.toString();
    }
    return cache[toSeconds];
}
/**
 * parseTimeFull - always returns value like MM:SS
 * @param {ms} number
 */
export function parseTimeFull(ms) {
    var toSeconds = Math.ceil(Math.abs(ms) / 1000);
    if (!cache2[toSeconds]) {
        var sec = toSeconds % 60;
        var min = Math.ceil((toSeconds - sec) / 60);
        cache2[toSeconds] = padTime(min.toString()) + ":" + padTime(sec.toString());
    }
    return cache2[toSeconds];
}
/**
 * parseTimeFullFromSeconds - always returns value like MM:SS
 * @param {s} number
 */
export function parseTimeFullFromSeconds(s) {
    var toSeconds = s;
    if (!cache3[toSeconds]) {
        var sec = toSeconds % 60;
        var min = Math.ceil((toSeconds - sec) / 60);
        cache3[toSeconds] = padTime(min.toString()) + ":" + padTime(sec.toString());
    }
    return cache3[toSeconds];
}
/**
 * parseTimeInMinutes - always returns value like MM
 * @param {ms} number
 */
export function parseTimeInMinutes(ms) {
    var toSeconds = Math.ceil(Math.abs(ms) / 1000);
    if (!cache4[toSeconds]) {
        var sec = toSeconds % 60;
        var min = Math.ceil((toSeconds - sec) / 60);
        cache4[toSeconds] = min.toString();
    }
    return cache4[toSeconds];
}
//# sourceMappingURL=ParseTime.js.map